<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectInvoiceNumber"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Nº Fatura
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    invoiceNumberList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      selectInvoiceNumber: this.value,
      options: [],
    };
  },
  async mounted() {
    await this.handleGetInvoiceNumberOptions();
  },
  methods: {
    async handleGetInvoiceNumberOptions() {
      const uniqueNames = new Set(this.invoiceNumberList);
      const listUniqueNames = Array.from(uniqueNames);

      this.options = listUniqueNames.reduce((accum, item) => {
        if (item && item !== 'undefined' && item !== undefined) {
          return [
            ...accum,
            {
              value: item.trim(),
              text: item,
            },
          ];
        } else {
          return accum;
        }
      }, []);
    },
    handleChange() {
      this.$emit('input', this.selectInvoiceNumber);
    },
  },
};
</script>
